import type { NavGroup } from '@graftcode/design-system'

export const VISION_MENU_GROUPS: NavGroup[] = [
  {
    items: [],
  },
]

export const VISION_MAIN_CONTENT = {
  title: 'Vision',
  description: 'See library installation command and see all methods and try them out below',
  actionButtonLabel: 'Create gateway',
} as const
